import { useState } from "react";
import { Button } from "@mui/material";
import "../index.css";
import { setAuthToken } from "../utils/tokenHeaders";

const prodURL = "/api";
const url =
  window.location.hostname === "localhost"
    ? "http://localhost:3004/api"
    : prodURL;

export default function Price() {
  const [data] = useState([
    {
      id: 1,
      value: 10,
      price: 500,
      text: "Стартовый набор",
      description: "Достаточно чтобы попробовать",
    },
    {
      id: 2,
      value: 25,
      price: 1125,
      text: "Выгодный пакет",
      description: "Оптимально для работы",
    },
    {
      id: 3,
      value: 50,
      price: 2000,
      text: "Максимальная выгода",
      description: "Для большой аудитории",
    },
  ]);

  const handlePayment = async (el) => {
    const response = await fetch(`${url}/payment/create-payment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: setAuthToken(),
      },
      body: JSON.stringify({
        id: el.id,
        price: el.price,
      }),
    });

    const result = await response.json();

    if (result.confirmation) {
      if (result.confirmation.confirmation_url) {
        window.open(result.confirmation.confirmation_url, "_blank");
      }
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "800px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "30px",
          }}
        >
          <h3>Выберите что больше подходит для вас!</h3>
        </div>
        <div
          style={{
            display: "flex",
            gap: "25px",
            padding: "15px 0",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {data.map((el) => {
            return (
              <div className="priceWrapper" key={el.id}>
                <div style={{ fontSize: "22px" }}>{el.text}</div>
                <div
                  style={{
                    display: "flex",
                    height: "30px",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "white",
                    color: "black",
                    fontWeight: "bolder",
                    fontSize: "20px",
                    padding: "10px 10px",
                  }}
                >
                  <div className="priceBlock">
                    <div>Ключей:</div>
                    <div style={{ display: "flex", gap: "3px" }}>
                      <div>{el.value}</div>
                    </div>
                  </div>
                </div>
                <div>{el.description}</div>
                <div className="priceBlock">
                  <div>Цена:</div>
                  <div style={{ display: "flex", gap: "3px" }}>
                    <div>{el.price}</div>
                    <p>&#8381;</p>
                  </div>
                </div>
                <div className="priceBlock">
                  <div>Цена за один ключ:</div>
                  <div style={{ display: "flex", gap: "3px" }}>
                    <div>{el.price / el.value}</div>
                    <p>&#8381;</p>
                  </div>
                </div>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => handlePayment(el)}
                >
                  Купить
                </Button>
              </div>
            );
          })}
        </div>
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            gap: "15px",
          }}
        >
          <div>
            Оплата производится при техническом участии -{" "}
            <a href="https://yoomoney.ru" target="_blank" rel="noreferrer">
              ЮMoney
            </a>
          </div>
          <div>
            Обработка платежа может занимать время (точные сроки можно уточнить
            на сайте ЮMoney)
          </div>
          <div>
            После подтверждения платежа со стороны платёжной системы, веб
            сервисом будет начислен пакет ключей
          </div>
          <div>В случае возникновения проблем, можете написать в поддержку</div>
        </div>
      </div>
    </>
  );
}
